module.exports = __webpack_public_path__ + "img/admin.41b90573.png";